import FormService from '../../services/FormService';
import formInput from '../../components/FormInput';

export default {
    components: {formInput},
    data() {
        return {
            reserved_seats: null,
            reservedSeatsArray: [],
            backgroundColorOne: '#000',
            backgroundColorTwo: '#4cd69a',
            textColorOne: '#969ca6',
            textColorTwo: '#ffe065',
            colors: {
                '#000': 'black',
                '#54afff': 'blue',
                '#00ffa2': 'green1',
                '#969ca6': 'graybg',
                '#ff5488': 'red2',
                '#ffe065': 'yellow',
                '#4cd69a': 'green',
            },
            form: new FormService({
                active_days: null,
                reserved_seats: null,
                reserved_seats_allow_time: null,
                id: null,
                timetable_colors: '',
                presale_fee: null,
                presale_hour: null,
            }),
        }
    },
    methods: {
        save() {
            let timetable_colors = {
                'bgone': this.backgroundColorOne,
                'bgtwo': this.backgroundColorTwo,
                'txtone': this.textColorOne,
                'txttwo': this.textColorTwo
            };
            this.form.timetable_colors = JSON.stringify(timetable_colors);
            this.reservedSeatsArray = isNaN(this.reservedSeatsArray[0]) ? [] : this.reservedSeatsArray;
            this.form.reserved_seats = JSON.stringify(this.reservedSeatsArray);
            this.form.reserved_seats_to = parseInt(this.form.reserved_seats_to);
            this.form.put('settings.update', this.form.id)
                .then(res => {
                    if (!res.errors) {
                        this.reservedSeatsArray = JSON.parse(res.data.reserved_seats);
                        this.parseColors(res.data.timetable_colors);
                        this.$notify({
                            type: 'success',
                            group: 'foo',
                            title: 'Успешно!!!',
                            text: this.i18n('"Settings saved!"')
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            group: 'foo',
                            title: 'ООПС!!!',
                            text: res.errors[0]
                        });
                    }
                })
        },

        onlyNumbers($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 && keyCode !==44 && keyCode !==45) || keyCode > 57 ) { // 46 is dot
                $event.preventDefault();
            }
        },
        check($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            let value = this.reserved_seats;
            let counter = 0;
            let main_array = [];

            for(let k in value){
                main_array.push(value[k]);
            }

            for(let x in value){
                if(value[0].charCodeAt(0) === 44 || value[0].charCodeAt(0) === 45){
                    this.reserved_seats = null;
                }
                counter++;
                if(counter > 2 && value[x].charCodeAt(0) === 45 && value[x - 2].charCodeAt(0) === 45){
                    main_array.splice(x, 1);
                    $event.preventDefault();
                    let str = '';
                    for(let k in main_array){
                        str = str + main_array[k];
                    }
                    this.reserved_seats = str;
                    return false;
                }
                if(counter > 0 && (
                    keyCode === 188 &&
                    value[counter-1].charCodeAt(0) === 44 &&
                    value[counter] !== undefined &&
                    value[counter].charCodeAt(0) === 44 ||

                    keyCode === 189 &&
                    value[counter-1].charCodeAt(0) === 45 &&
                    value[counter] !== undefined &&
                    value[counter].charCodeAt(0) === 45 ||

                    keyCode === 189 &&
                    value[counter-1].charCodeAt(0) === 44 &&
                    value[counter] !== undefined &&
                    value[counter].charCodeAt(0) === 45 ||

                    keyCode === 188 &&
                    value[counter-1].charCodeAt(0) === 45 &&
                    value[counter] !== undefined &&
                    value[counter].charCodeAt(0) === 44 )
                ){
                    $event.preventDefault();
                    main_array.splice(counter, 1);
                    let str = '';
                    for(let k in main_array){
                        str = str + main_array[k];
                    }
                    this.reserved_seats = str;
                }
            }
        },
        createSeatsOfArray(){
            let str = this.reserved_seats;
            let createdString = str.split(',');
            let newArray = [];

            for(let x in createdString){
                if(createdString[x].length > 1 && createdString[x].includes('-')){
                    let newString = createdString[x].split('-');
                    let to = parseInt(newString[1]);
                    let start = parseInt(newString[0]);

                    for(let k = start; k<=to; k++){
                        newArray.push(parseInt(k));
                    }

                } else {
                    newArray.push(parseInt(createdString[x]));
                }
            }

            this.reserved_seats = newArray;
            this.reservedSeatsArray = newArray;

        },
        selectBackgroundColorOne(color){
            this.backgroundColorOne = color;
        },
        selectBackgroundColorTwo(color){
            this.backgroundColorTwo = color;
        },
        selectTextColorOne(color){
            this.textColorOne = color;
        },
        selectTextColorTwo(color){
            this.textColorTwo = color;
        },
        parseColors(colors){
            let timetable_colors = JSON.parse(colors);
            this.backgroundColorOne = timetable_colors.bgone;
            this.backgroundColorTwo = timetable_colors.bgtwo;
            this.textColorOne = timetable_colors.txtone;
            this.textColorTwo = timetable_colors.txttwo;
        }
    },
    created() {
        this.$api.get('settings.index')
            .then(res => {
                this.form.setData(res.data);
                this.reserved_seats = JSON.parse(res.data.reserved_seats);
                this.reservedSeatsArray = JSON.parse(res.data.reserved_seats);
                this.parseColors(res.data.timetable_colors);
            })
    },
}
